module.exports = __webpack_public_path__ + "images/cce231fa52946a335574dd47b96241c8.png";